{
    "TelephonenosLabel": "Telefoonnummer(s):",
    "AcdagentsLabel": "ACD-agent(en):",
    "LocationLabel": "Locatie van\/naar:",
    "LocationOptionAny": "[Elke oproep van\/naar deze locaties]",
    "LocationOptionFrom": "Behandel dit bericht door deze stappen te volgen:",
    "LocationOptionTo": "Alleen oproepen naar deze locaties",
    "LocationalFiltering_SectionHeader": "Locatiefiltering",
    "LocationalFiltering_AnyPlaceholder": "[Elk]",
    "LocationalFiltering_DevicesLabel": "Apparaat(en):",
    "NAME": "LocationalFiltering",
    "TelephonenosLabelDNIS": "Tel nr(s) \/ DNIS nr(s):",
    "TelephonenoDescriptionsLabel": "Telefoonnr. Beschrijving(en):",
    "AcdagentsLabel_MST": "Agent(en):"
}